// extracted by mini-css-extract-plugin
module.exports = {"custom-search-group":"BaseTableHeader_custom-search-group__Uzm33"};